import { render, staticRenderFns } from "./scan-payment-counselor.vue?vue&type=template&id=ba96f77a&"
import script from "./scan-payment-counselor.vue?vue&type=script&lang=js&"
export * from "./scan-payment-counselor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports